var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmbrillLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242.116,
    height: 58.903,
    viewBox: "0 0 242.116 58.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.239,
    y1: 7.316,
    x2: 0.501,
    y2: 0.074,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65c6da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d60ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.282,
    y1: 4.956,
    x2: 0.637,
    y2: -2.133,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.218,
    y1: 7.345,
    x2: 0.512,
    y2: 0.213,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.34,
    y1: 5.811,
    x2: 0.564,
    y2: -1.004,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.196,
    y1: 6.363,
    x2: 0.476,
    y2: 0.923,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.368,
    y1: 3.713,
    x2: 0.647,
    y2: -3.058,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.38,
    y1: 3.888,
    x2: 0.655,
    y2: -2.982,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.376,
    y1: 3.78,
    x2: 0.669,
    y2: -4.843,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.404,
    y1: 2.419,
    x2: 0.683,
    y2: -3.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.249,
    y1: 5.139,
    x2: 0.602,
    y2: -1.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.318,
    y1: 5.936,
    x2: 0.542,
    y2: -0.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.204,
    y1: 9.56,
    x2: 0.498,
    y2: 0.934,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e31368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d60ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65c6da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107405",
    "data-name": "Group 107405",
    transform: "translate(-26.462 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107373",
    "data-name": "Group 107373",
    transform: "translate(26.462 19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107366",
    "data-name": "Group 107366",
    transform: "translate(70.301 12.169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107365",
    "data-name": "Group 107365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107362",
    "data-name": "Group 107362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107361",
    "data-name": "Group 107361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162043",
    "data-name": "Path 162043",
    d: "M28.876,184.7H14.856a6.237,6.237,0,0,1-1.764-.283,5.174,5.174,0,0,1-1.771-.934,5.234,5.234,0,0,1-1.36-1.689,5.42,5.42,0,0,1-.546-2.548V165.219a1.958,1.958,0,0,1,.15-.763,2,2,0,0,1,.411-.627,1.85,1.85,0,0,1,.62-.419,2.011,2.011,0,0,1,.778-.15h17.5v3.887H13.3V179.24a1.578,1.578,0,0,0,.4,1.166,1.6,1.6,0,0,0,1.181.4h13.99Zm-1.748-8.758H14.856V172.02H27.128Z",
    transform: "translate(-9.415 -162.955)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162044",
    "data-name": "Path 162044",
    d: "M66.161,184.631H62.245V171.867l-6.891,12.121a1.693,1.693,0,0,1-.71.7,2.077,2.077,0,0,1-.979.239,1.961,1.961,0,0,1-.949-.239,1.712,1.712,0,0,1-.695-.7L45.1,171.867v12.764H41.214V164.856a1.948,1.948,0,0,1,1.435-1.9,2.039,2.039,0,0,1,.627-.052,2.1,2.1,0,0,1,.606.134,1.831,1.831,0,0,1,.935.8l8.848,15.381,8.848-15.381a1.9,1.9,0,0,1,.949-.807,2.021,2.021,0,0,1,1.263-.074,1.952,1.952,0,0,1,1.031.7,1.906,1.906,0,0,1,.4,1.2Z",
    transform: "translate(-14.94 -162.891)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162045",
    "data-name": "Path 162045",
    d: "M101.957,179.987a5.368,5.368,0,0,1-.246,1.539,4.453,4.453,0,0,1-2.265,2.7,4.682,4.682,0,0,1-2.2.471H82.5a2.011,2.011,0,0,1-.778-.149,1.911,1.911,0,0,1-.621-.411,1.888,1.888,0,0,1-.411-.621,1.992,1.992,0,0,1-.15-.777V165.219a1.958,1.958,0,0,1,.15-.763,1.979,1.979,0,0,1,.411-.627,1.853,1.853,0,0,1,.621-.419,2.011,2.011,0,0,1,.778-.15h13a5.226,5.226,0,0,1,1.539.254,4.685,4.685,0,0,1,1.533.815,4.481,4.481,0,0,1,1.181,1.457,4.682,4.682,0,0,1,.47,2.2v.732a7.988,7.988,0,0,1-.344,2.219,7.322,7.322,0,0,1-1.106,2.25,6.9,6.9,0,0,1,1.233.972,6.229,6.229,0,0,1,1.009,1.315,6.991,6.991,0,0,1,.688,1.689,8,8,0,0,1,.254,2.078Zm-3.887-.747a3.7,3.7,0,0,0-.239-1.368,3.019,3.019,0,0,0-.673-1.039,2.919,2.919,0,0,0-1.046-.665,3.865,3.865,0,0,0-1.376-.231H85.979V172.02h7.01a3.865,3.865,0,0,0,1.375-.231,2.915,2.915,0,0,0,1.047-.665,2.951,2.951,0,0,0,.665-1.039,3.819,3.819,0,0,0,.231-1.367v-.732q0-.837-.807-.837H84.424v13.661H97.249c.069,0,.155,0,.254-.015a.556.556,0,0,0,.478-.344,1.125,1.125,0,0,0,.089-.493Z",
    transform: "translate(-21.772 -162.955)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162046",
    "data-name": "Path 162046",
    d: "M135.673,170.466a7.925,7.925,0,0,1-.329,2.376,6.681,6.681,0,0,1-.889,1.846,6.263,6.263,0,0,1-1.293,1.367,7.751,7.751,0,0,1-1.532.935,7.344,7.344,0,0,1-1.615.53,7.744,7.744,0,0,1-1.532.164l8.116,7.01h-6.009l-8.1-7.01h-2.8V173.8h8.789a4.492,4.492,0,0,0,1.338-.307,3.323,3.323,0,0,0,1.046-.665,2.845,2.845,0,0,0,.68-1.009,3.578,3.578,0,0,0,.24-1.353v-2.452a1.2,1.2,0,0,0-.083-.5.579.579,0,0,0-.478-.351,2.523,2.523,0,0,0-.261-.015H118.141V184.7h-3.887V165.219a1.959,1.959,0,0,1,.15-.763,1.979,1.979,0,0,1,.411-.627,1.853,1.853,0,0,1,.621-.419,2.011,2.011,0,0,1,.777-.15h14.753a4.681,4.681,0,0,1,2.2.471,4.485,4.485,0,0,1,1.458,1.181,4.591,4.591,0,0,1,.807,1.532,5.377,5.377,0,0,1,.246,1.54Z",
    transform: "translate(-27.629 -162.955)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162047",
    "data-name": "Path 162047",
    d: "M152.526,184.7H148.64V163.261h3.886Z",
    transform: "translate(-33.603 -162.955)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162048",
    "data-name": "Path 162048",
    d: "M182.233,184.7H164.505a2.011,2.011,0,0,1-.778-.149,1.877,1.877,0,0,1-1.031-1.032,1.993,1.993,0,0,1-.15-.777V163.261h3.887v17.548h15.8Z",
    transform: "translate(-36.02 -162.955)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162049",
    "data-name": "Path 162049",
    d: "M213.217,184.7H195.49a2.008,2.008,0,0,1-.777-.149,1.87,1.87,0,0,1-1.031-1.032,1.992,1.992,0,0,1-.15-.777V163.261h3.886v17.548h15.8Z",
    transform: "translate(-41.403 -162.955)",
    fill: "#002535"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107364",
    "data-name": "Group 107364",
    transform: "translate(0 27.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107363",
    "data-name": "Group 107363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162050",
    "data-name": "Path 162050",
    d: "M12.608,199.589v3.192h-.882v-3.192l-2.31-3.672H10.45l1.7,2.79h.04l1.657-2.79H14.88Z",
    transform: "translate(-9.415 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162051",
    "data-name": "Path 162051",
    d: "M15.448,200.857a2.486,2.486,0,0,1,.681-1.793,2.323,2.323,0,0,1,1.736-.71,2.288,2.288,0,0,1,1.724.71,2.671,2.671,0,0,1,0,3.585,2.287,2.287,0,0,1-1.724.709,2.323,2.323,0,0,1-1.736-.709A2.485,2.485,0,0,1,15.448,200.857Zm.882,0a1.719,1.719,0,0,0,.441,1.227,1.506,1.506,0,0,0,2.185,0,1.91,1.91,0,0,0,0-2.444,1.483,1.483,0,0,0-2.185,0A1.7,1.7,0,0,0,16.33,200.857Z",
    transform: "translate(-10.463 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162052",
    "data-name": "Path 162052",
    d: "M26.442,203.237H25.6v-.651h-.039a1.582,1.582,0,0,1-.617.576,1.779,1.779,0,0,1-.868.229,1.734,1.734,0,0,1-1.329-.494,1.97,1.97,0,0,1-.464-1.4v-2.951h.882v2.894a1.036,1.036,0,0,0,1.16,1.15,1.107,1.107,0,0,0,.882-.426,1.553,1.553,0,0,0,.354-1.021v-2.6h.882Z",
    transform: "translate(-11.65 -196.22)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162053",
    "data-name": "Path 162053",
    d: "M29.613,203.208h-.882v-4.7h.844v.767h.038a1.265,1.265,0,0,1,.552-.638,1.538,1.538,0,0,1,.82-.265,1.656,1.656,0,0,1,.651.116l-.268.854a1.464,1.464,0,0,0-.517-.067,1.141,1.141,0,0,0-.868.4,1.35,1.35,0,0,0-.369.939Z",
    transform: "translate(-12.771 -196.191)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162054",
    "data-name": "Path 162054",
    d: "M37.692,196.761v6.019H36.81v-6.019H34.894v-.844H39.61v.844Z",
    transform: "translate(-13.842 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162055",
    "data-name": "Path 162055",
    d: "M41.831,203.208h-.882v-4.7h.844v.767h.038a1.269,1.269,0,0,1,.552-.638,1.538,1.538,0,0,1,.82-.265,1.656,1.656,0,0,1,.651.116l-.268.854a1.464,1.464,0,0,0-.517-.067,1.141,1.141,0,0,0-.868.4,1.35,1.35,0,0,0-.369.939Z",
    transform: "translate(-14.894 -196.191)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162056",
    "data-name": "Path 162056",
    d: "M49.39,203.237h-.842v-.651h-.04a1.577,1.577,0,0,1-.617.576,1.776,1.776,0,0,1-.868.229A1.733,1.733,0,0,1,45.7,202.9a1.966,1.966,0,0,1-.464-1.4v-2.951h.882v2.894a1.037,1.037,0,0,0,1.16,1.15,1.107,1.107,0,0,0,.882-.426,1.553,1.553,0,0,0,.354-1.021v-2.6h.882Z",
    transform: "translate(-15.638 -196.22)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162057",
    "data-name": "Path 162057",
    d: "M55.153,201.9a1.268,1.268,0,0,1-.538,1.035,2.116,2.116,0,0,1-1.351.421,2.145,2.145,0,0,1-1.247-.369,2.039,2.039,0,0,1-.767-.973l.786-.335a1.482,1.482,0,0,0,.5.657,1.224,1.224,0,0,0,.724.234,1.27,1.27,0,0,0,.7-.183.513.513,0,0,0,.282-.431c0-.3-.229-.521-.69-.662l-.806-.2q-1.37-.346-1.37-1.322a1.223,1.223,0,0,1,.522-1.031,2.4,2.4,0,0,1,2.463-.092,1.618,1.618,0,0,1,.7.8l-.785.326a1,1,0,0,0-.437-.466,1.368,1.368,0,0,0-.675-.167,1.135,1.135,0,0,0-.619.172.5.5,0,0,0-.273.421c0,.27.253.461.758.576l.708.183Q55.153,200.837,55.153,201.9Z",
    transform: "translate(-16.683 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162058",
    "data-name": "Path 162058",
    d: "M58.756,203.012a1.347,1.347,0,0,1-.954-.354,1.325,1.325,0,0,1-.388-.988v-2.627H56.59v-.8h.823V196.8H58.3v1.439h1.149v.8H58.3v2.34a.857.857,0,0,0,.182.638.588.588,0,0,0,.411.166.819.819,0,0,0,.207-.024.932.932,0,0,0,.188-.062l.278.786A2.345,2.345,0,0,1,58.756,203.012Z",
    transform: "translate(-17.611 -195.918)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162059",
    "data-name": "Path 162059",
    d: "M63.178,203.358a2.245,2.245,0,0,1-1.705-.709,2.5,2.5,0,0,1-.673-1.792,2.559,2.559,0,0,1,.652-1.788,2.344,2.344,0,0,1,3.331-.04,2.708,2.708,0,0,1,.619,1.895l-.009.1H61.7a1.538,1.538,0,0,0,.461,1.112,1.486,1.486,0,0,0,2.377-.423l.786.383a2.327,2.327,0,0,1-.877.93A2.43,2.43,0,0,1,63.178,203.358Zm-1.41-3.067h2.7a1.168,1.168,0,0,0-.4-.81,1.386,1.386,0,0,0-.963-.321,1.278,1.278,0,0,0-.859.307A1.469,1.469,0,0,0,61.768,200.291Z",
    transform: "translate(-18.342 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162060",
    "data-name": "Path 162060",
    d: "M69.428,202.935a2.071,2.071,0,0,1-1.583-.727,2.74,2.74,0,0,1,0-3.548,2.07,2.07,0,0,1,1.583-.729,2.019,2.019,0,0,1,.944.221,1.66,1.66,0,0,1,.657.584h.037l-.037-.651v-2.168h.882v6.864h-.844v-.651h-.037a1.66,1.66,0,0,1-.657.584A2.018,2.018,0,0,1,69.428,202.935Zm.142-.8a1.35,1.35,0,0,0,1.064-.469,1.947,1.947,0,0,0,0-2.444,1.356,1.356,0,0,0-1.064-.48,1.377,1.377,0,0,0-1.063.48,1.752,1.752,0,0,0-.431,1.217,1.725,1.725,0,0,0,.431,1.216A1.377,1.377,0,0,0,69.57,202.13Z",
    transform: "translate(-19.453 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162061",
    "data-name": "Path 162061",
    d: "M81.178,195.917v.844H78.053v2.176H80.87v.825H78.053v2.175h3.125v.844H77.171v-6.864Z",
    transform: "translate(-21.187 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162062",
    "data-name": "Path 162062",
    d: "M84.155,203.2h-.882v-4.7h.844v.651h.038a1.559,1.559,0,0,1,.619-.576,1.725,1.725,0,0,1,1.739.011,1.413,1.413,0,0,1,.576.662,1.832,1.832,0,0,1,1.619-.9,1.588,1.588,0,0,1,1.256.5,2.076,2.076,0,0,1,.442,1.42V203.2h-.883v-2.8a1.508,1.508,0,0,0-.239-.954.989.989,0,0,0-.8-.293,1.052,1.052,0,0,0-.854.431,1.575,1.575,0,0,0-.345,1.016v2.6H86.4v-2.8a1.5,1.5,0,0,0-.24-.954.987.987,0,0,0-.8-.293,1.052,1.052,0,0,0-.854.431,1.575,1.575,0,0,0-.345,1.016Z",
    transform: "translate(-22.247 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162063",
    "data-name": "Path 162063",
    d: "M95.757,202.935a2.02,2.02,0,0,1-.945-.221,1.66,1.66,0,0,1-.657-.584h-.038v.651h-.844v-6.864h.882v2.168l-.038.651h.038a1.66,1.66,0,0,1,.657-.584,2.081,2.081,0,0,1,2.516.507,2.709,2.709,0,0,1,0,3.548A2.019,2.019,0,0,1,95.757,202.935Zm-.145-.8a1.375,1.375,0,0,0,1.064-.48,1.729,1.729,0,0,0,.431-1.216,1.756,1.756,0,0,0-.431-1.217,1.431,1.431,0,0,0-2.138,0,1.983,1.983,0,0,0,0,2.444A1.4,1.4,0,0,0,95.612,202.13Z",
    transform: "translate(-23.984 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162064",
    "data-name": "Path 162064",
    d: "M102.124,203.358a2.247,2.247,0,0,1-1.705-.709,2.5,2.5,0,0,1-.672-1.792,2.559,2.559,0,0,1,.651-1.788,2.163,2.163,0,0,1,1.669-.715,2.14,2.14,0,0,1,1.662.675,2.708,2.708,0,0,1,.619,1.895l-.008.1h-3.693a1.538,1.538,0,0,0,.461,1.112,1.486,1.486,0,0,0,2.377-.423l.785.383a2.315,2.315,0,0,1-.877.93A2.428,2.428,0,0,1,102.124,203.358Zm-1.41-3.067h2.7a1.164,1.164,0,0,0-.4-.81,1.389,1.389,0,0,0-.963-.321,1.282,1.282,0,0,0-.86.307A1.473,1.473,0,0,0,100.715,200.291Z",
    transform: "translate(-25.109 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162065",
    "data-name": "Path 162065",
    d: "M108.374,202.935a2.074,2.074,0,0,1-1.583-.727,2.742,2.742,0,0,1,0-3.548,2.072,2.072,0,0,1,1.583-.729,2.025,2.025,0,0,1,.944.221,1.652,1.652,0,0,1,.656.584h.038l-.038-.651v-2.168h.882v6.864h-.844v-.651h-.038a1.652,1.652,0,0,1-.656.584A2.024,2.024,0,0,1,108.374,202.935Zm.143-.8a1.351,1.351,0,0,0,1.064-.469,1.947,1.947,0,0,0,0-2.444,1.356,1.356,0,0,0-1.064-.48,1.379,1.379,0,0,0-1.064.48,1.755,1.755,0,0,0-.431,1.217,1.729,1.729,0,0,0,.431,1.216A1.379,1.379,0,0,0,108.517,202.13Z",
    transform: "translate(-26.22 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162066",
    "data-name": "Path 162066",
    d: "M115.115,202.935a2.071,2.071,0,0,1-1.583-.727,2.74,2.74,0,0,1,0-3.548,2.07,2.07,0,0,1,1.583-.729,2.019,2.019,0,0,1,.944.221,1.66,1.66,0,0,1,.657.584h.037l-.037-.651v-2.168h.882v6.864h-.844v-.651h-.037a1.66,1.66,0,0,1-.657.584A2.018,2.018,0,0,1,115.115,202.935Zm.142-.8a1.35,1.35,0,0,0,1.064-.469,1.947,1.947,0,0,0,0-2.444,1.356,1.356,0,0,0-1.064-.48,1.377,1.377,0,0,0-1.063.48,1.752,1.752,0,0,0-.431,1.217,1.725,1.725,0,0,0,.431,1.216A1.377,1.377,0,0,0,115.257,202.13Z",
    transform: "translate(-27.391 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162067",
    "data-name": "Path 162067",
    d: "M122,203.358a2.247,2.247,0,0,1-1.705-.709,2.5,2.5,0,0,1-.672-1.792,2.559,2.559,0,0,1,.651-1.788,2.163,2.163,0,0,1,1.669-.715,2.14,2.14,0,0,1,1.662.675,2.708,2.708,0,0,1,.619,1.895l-.008.1h-3.693a1.541,1.541,0,0,0,.46,1.112,1.487,1.487,0,0,0,2.378-.423l.785.383a2.321,2.321,0,0,1-.877.93A2.428,2.428,0,0,1,122,203.358Zm-1.41-3.067h2.7a1.161,1.161,0,0,0-.4-.81,1.386,1.386,0,0,0-.963-.321,1.28,1.28,0,0,0-.859.307A1.474,1.474,0,0,0,120.591,200.291Z",
    transform: "translate(-28.562 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162068",
    "data-name": "Path 162068",
    d: "M128.25,202.935a2.074,2.074,0,0,1-1.583-.727,2.742,2.742,0,0,1,0-3.548,2.072,2.072,0,0,1,1.583-.729,2.019,2.019,0,0,1,.944.221,1.649,1.649,0,0,1,.657.584h.038l-.038-.651v-2.168h.882v6.864h-.844v-.651h-.038a1.649,1.649,0,0,1-.657.584A2.018,2.018,0,0,1,128.25,202.935Zm.143-.8a1.351,1.351,0,0,0,1.064-.469,1.947,1.947,0,0,0,0-2.444,1.356,1.356,0,0,0-1.064-.48,1.378,1.378,0,0,0-1.064.48,1.755,1.755,0,0,0-.431,1.217,1.729,1.729,0,0,0,.431,1.216A1.378,1.378,0,0,0,128.393,202.13Z",
    transform: "translate(-29.673 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162069",
    "data-name": "Path 162069",
    d: "M139.786,200.914a1.788,1.788,0,0,1-.662,1.45,2.524,2.524,0,0,1-1.629.539,2.4,2.4,0,0,1-1.506-.5,2.539,2.539,0,0,1-.9-1.359l.844-.346a2.119,2.119,0,0,0,.239.555,1.73,1.73,0,0,0,.359.426,1.594,1.594,0,0,0,.455.278,1.388,1.388,0,0,0,.528.1,1.519,1.519,0,0,0,.987-.312,1.01,1.01,0,0,0,.383-.829.989.989,0,0,0-.316-.738,3,3,0,0,0-1.112-.576q-.823-.3-1.025-.4a1.765,1.765,0,0,1-1.093-1.64,1.672,1.672,0,0,1,.6-1.295,2.211,2.211,0,0,1,1.505-.536,2.318,2.318,0,0,1,1.362.4,1.893,1.893,0,0,1,.767.988l-.825.344a1.215,1.215,0,0,0-.455-.637,1.481,1.481,0,0,0-1.7.032.837.837,0,0,0-.355.7.8.8,0,0,0,.279.61,4.791,4.791,0,0,0,1.332.611,3.4,3.4,0,0,1,1.491.869A1.867,1.867,0,0,1,139.786,200.914Z",
    transform: "translate(-31.249 -195.732)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162070",
    "data-name": "Path 162070",
    d: "M141.666,200.857a2.486,2.486,0,0,1,.681-1.793,2.324,2.324,0,0,1,1.736-.71,2.287,2.287,0,0,1,1.724.71,2.671,2.671,0,0,1,0,3.585,2.287,2.287,0,0,1-1.724.709,2.323,2.323,0,0,1-1.736-.709A2.485,2.485,0,0,1,141.666,200.857Zm.882,0a1.719,1.719,0,0,0,.441,1.227,1.506,1.506,0,0,0,2.185,0,1.91,1.91,0,0,0,0-2.444,1.483,1.483,0,0,0-2.185,0A1.7,1.7,0,0,0,142.548,200.857Z",
    transform: "translate(-32.392 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162071",
    "data-name": "Path 162071",
    d: "M149.428,195.917v6.864h-.882v-6.864Z",
    transform: "translate(-33.587 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162072",
    "data-name": "Path 162072",
    d: "M155.142,203.237H154.3v-.651h-.04a1.574,1.574,0,0,1-.616.576,1.779,1.779,0,0,1-.868.229,1.733,1.733,0,0,1-1.329-.494,1.966,1.966,0,0,1-.464-1.4v-2.951h.882v2.894a1.037,1.037,0,0,0,1.161,1.15,1.107,1.107,0,0,0,.882-.426,1.553,1.553,0,0,0,.354-1.021v-2.6h.882Z",
    transform: "translate(-34.01 -196.22)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162073",
    "data-name": "Path 162073",
    d: "M159.285,203.012a1.347,1.347,0,0,1-.954-.354,1.319,1.319,0,0,1-.388-.988v-2.627h-.824v-.8h.824V196.8h.883v1.439h1.15v.8h-1.15v2.34a.857.857,0,0,0,.183.638.587.587,0,0,0,.411.166.816.816,0,0,0,.206-.024.9.9,0,0,0,.188-.062l.279.786A2.338,2.338,0,0,1,159.285,203.012Z",
    transform: "translate(-35.077 -195.918)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162074",
    "data-name": "Path 162074",
    d: "M162.89,196.448a.6.6,0,0,1-.182.442.625.625,0,0,1-.882,0,.624.624,0,1,1,1.063-.442Zm-.182,1.621v4.7h-.882v-4.7Z",
    transform: "translate(-35.863 -195.748)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162075",
    "data-name": "Path 162075",
    d: "M164.057,200.857a2.486,2.486,0,0,1,.681-1.793,2.323,2.323,0,0,1,1.736-.71,2.288,2.288,0,0,1,1.724.71,2.671,2.671,0,0,1,0,3.585,2.287,2.287,0,0,1-1.724.709,2.323,2.323,0,0,1-1.736-.709A2.485,2.485,0,0,1,164.057,200.857Zm.882,0a1.719,1.719,0,0,0,.441,1.227,1.506,1.506,0,0,0,2.185,0,1.91,1.91,0,0,0,0-2.444,1.483,1.483,0,0,0-2.185,0A1.7,1.7,0,0,0,164.939,200.857Z",
    transform: "translate(-36.282 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162076",
    "data-name": "Path 162076",
    d: "M170.879,198.509h.844v.651h.038a1.559,1.559,0,0,1,.619-.576,1.781,1.781,0,0,1,.868-.23,1.732,1.732,0,0,1,1.327.495,1.963,1.963,0,0,1,.465,1.4V203.2h-.882V200.31a1.038,1.038,0,0,0-1.16-1.15,1.1,1.1,0,0,0-.882.426,1.54,1.54,0,0,0-.356,1.021v2.6h-.882Z",
    transform: "translate(-37.467 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162077",
    "data-name": "Path 162077",
    d: "M181.021,200v2.779h-.882v-6.864h2.337a2.111,2.111,0,0,1,1.515.595,1.982,1.982,0,0,1,0,2.905,2.108,2.108,0,0,1-1.515.584Zm0-3.24v2.4H182.5a1.171,1.171,0,0,0,.873-.354,1.155,1.155,0,0,0,.354-.844,1.142,1.142,0,0,0-.354-.834,1.155,1.155,0,0,0-.873-.364Z",
    transform: "translate(-39.076 -195.764)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162078",
    "data-name": "Path 162078",
    d: "M188.107,198.354a2.193,2.193,0,0,1,1.543.522,1.858,1.858,0,0,1,.566,1.434V203.2h-.844v-.651h-.04a1.679,1.679,0,0,1-1.456.8,1.9,1.9,0,0,1-1.3-.459,1.468,1.468,0,0,1-.523-1.15,1.4,1.4,0,0,1,.552-1.16,2.318,2.318,0,0,1,1.472-.431,2.614,2.614,0,0,1,1.294.287v-.2a1.009,1.009,0,0,0-.364-.782,1.251,1.251,0,0,0-.853-.32,1.349,1.349,0,0,0-1.17.622l-.777-.488A2.168,2.168,0,0,1,188.107,198.354Zm-1.141,3.413a.7.7,0,0,0,.292.574,1.069,1.069,0,0,0,.686.231,1.407,1.407,0,0,0,.992-.413,1.287,1.287,0,0,0,.436-.968,1.816,1.816,0,0,0-1.149-.326,1.5,1.5,0,0,0-.9.259A.768.768,0,0,0,186.966,201.767Z",
    transform: "translate(-40.104 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162079",
    "data-name": "Path 162079",
    d: "M192.413,198.239h.844v.767h.038a1.585,1.585,0,0,1,1.621-.9l.182.021v.92l-.393-.037a1.405,1.405,0,0,0-1.01.378,1.274,1.274,0,0,0-.4.963v2.589h-.882Zm5.5,4.773a1.34,1.34,0,0,1-.953-.354,1.319,1.319,0,0,1-.388-.988v-2.627h-.825v-.8h.825V196.8h.882v1.439h1.149v.8h-1.149v2.34a.858.858,0,0,0,.182.638.589.589,0,0,0,.412.166.814.814,0,0,0,.2-.024.9.9,0,0,0,.188-.062l.278.786A2.346,2.346,0,0,1,197.915,203.012Z",
    transform: "translate(-41.208 -195.918)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162080",
    "data-name": "Path 162080",
    d: "M201.1,198.509h.844v.651h.038a1.559,1.559,0,0,1,.619-.576,1.778,1.778,0,0,1,.868-.23,1.73,1.73,0,0,1,1.327.495,1.959,1.959,0,0,1,.466,1.4V203.2h-.882V200.31a1.038,1.038,0,0,0-1.16-1.15,1.1,1.1,0,0,0-.882.426,1.539,1.539,0,0,0-.355,1.021v2.6H201.1Z",
    transform: "translate(-42.718 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162081",
    "data-name": "Path 162081",
    d: "M209.558,203.358a2.245,2.245,0,0,1-1.7-.709,2.5,2.5,0,0,1-.673-1.792,2.559,2.559,0,0,1,.652-1.788,2.344,2.344,0,0,1,3.332-.04,2.708,2.708,0,0,1,.618,1.895l-.008.1h-3.693a1.538,1.538,0,0,0,.461,1.112,1.486,1.486,0,0,0,2.377-.423l.786.383a2.327,2.327,0,0,1-.877.93A2.431,2.431,0,0,1,209.558,203.358Zm-1.409-3.067h2.7a1.168,1.168,0,0,0-.4-.81,1.386,1.386,0,0,0-.963-.321,1.278,1.278,0,0,0-.859.307A1.468,1.468,0,0,0,208.149,200.291Z",
    transform: "translate(-43.774 -196.188)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162082",
    "data-name": "Path 162082",
    d: "M214.723,203.208h-.882v-4.7h.844v.767h.038a1.269,1.269,0,0,1,.552-.638,1.538,1.538,0,0,1,.82-.265,1.656,1.656,0,0,1,.651.116l-.268.854a1.464,1.464,0,0,0-.517-.067,1.143,1.143,0,0,0-.868.4,1.35,1.35,0,0,0-.369.939Z",
    transform: "translate(-44.931 -196.191)",
    fill: "#002535"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107371",
    "data-name": "Group 107371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107368",
    "data-name": "Group 107368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107367",
    "data-name": "Group 107367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162083",
    "data-name": "Path 162083",
    d: "M69.905,45.647v6.884h2V45.647h8.176v-2H69.905Z",
    transform: "translate(-60.022 -33.824)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162084",
    "data-name": "Path 162084",
    d: "M63.472,95.544h2V86.472h-2v1.515H59.236a.657.657,0,1,0-.008.482h4.245v2.351h-1.16a.658.658,0,1,0-.008.482h1.167Z",
    transform: "translate(-53.59 -56.877)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162085",
    "data-name": "Path 162085",
    d: "M144.219,52.669h2V43.651h-9.072v2h7.076Z",
    transform: "translate(-96.221 -33.824)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162086",
    "data-name": "Path 162086",
    d: "M58.379,73.926h2V64.853h-2v2.794H57.21a.663.663,0,1,0,.009.484h1.16v2.351H54.134a.664.664,0,1,0,.008.483h4.237v2.477H49.788a.66.66,0,1,0-.042.482h8.633Z",
    transform: "translate(-48.496 -45.238)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162087",
    "data-name": "Path 162087",
    d: "M102.977,32.189h-.024V23.654a.66.66,0,1,0-.482-.042v8.577h-2.423V28.008A.658.658,0,1,0,99.566,28v4.19H97.215v-1.1a.658.658,0,1,0-.483-.008v1.112H93.905v2h9.072Z",
    transform: "translate(-72.943 -22.362)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162088",
    "data-name": "Path 162088",
    d: "M71.9,108.091h-2v9.5h9.553v-2H71.9Z",
    transform: "translate(-60.022 -68.516)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162089",
    "data-name": "Path 162089",
    d: "M143.5,115.754h-7.7v2h9.691v-9.361h-2Z",
    transform: "translate(-95.5 -68.677)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162090",
    "data-name": "Path 162090",
    d: "M92.565,126.34h4.184v1.116a.663.663,0,1,0,.484-.009V126.34h2.351v4.193a.664.664,0,1,0,.483-.008V126.34h1.569v-2H92.565Z",
    transform: "translate(-72.222 -77.267)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162091",
    "data-name": "Path 162091",
    d: "M113.63,126.34h0v8.538a.661.661,0,1,0,.482.042V126.34h2.423v4.185a.658.658,0,1,0,.482.008V126.34h2.352v1.107a.658.658,0,1,0,.482.008V126.34H122.7v-2H113.63Z",
    transform: "translate(-83.308 -77.267)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162092",
    "data-name": "Path 162092",
    d: "M159.355,87.908a.659.659,0,0,0-.617.433h-4.27V86.77h-2v9.073h2V91.66h1.2a.663.663,0,1,0-.009-.484h-1.192V88.824h4.278a.661.661,0,1,0,.609-.916Z",
    transform: "translate(-104.475 -57.038)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162093",
    "data-name": "Path 162093",
    d: "M163.723,73.378a.658.658,0,0,0-.589.366h-8.666V71.32h4.27a.657.657,0,1,0,.008-.482h-4.277V68.487h1.192a.658.658,0,1,0,.008-.483h-1.2V65.152h-2v9.072h10.619a.66.66,0,1,0,.631-.848Z",
    transform: "translate(-104.475 -45.399)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162094",
    "data-name": "Path 162094",
    d: "M120.387,36.17a.663.663,0,1,0-.484.009v1.1h-2.351v-4.19a.664.664,0,1,0-.483.008v4.181h-1.545v2H124.6v-2h-4.208Z",
    transform: "translate(-84.582 -27.456)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107370",
    "data-name": "Group 107370",
    transform: "translate(13.241 13.114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29485",
    "data-name": "Rectangle 29485",
    width: 30.42,
    height: 29.763,
    transform: "translate(0.98 0.825)",
    fill: "#002535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162095",
    "data-name": "Path 162095",
    d: "M77.18,50.77V83.443h33.394V50.77Zm30.419,20.6a5.094,5.094,0,0,1-2.076,1.981,4.427,4.427,0,0,1-3.8,4.979,3.965,3.965,0,0,1-2.646,2.228l-.048.012-.145.025-.048,0a8.139,8.139,0,0,1-.824.043,5.29,5.29,0,0,1-4.1-1.69,5.29,5.29,0,0,1-4.1,1.69,8.139,8.139,0,0,1-.824-.043l-.048,0-.145-.025-.048-.012a3.965,3.965,0,0,1-2.646-2.228,4.418,4.418,0,0,1-3.791-4.976,5.076,5.076,0,0,1-2.082-1.984,5.321,5.321,0,0,1-.5-3.741,2.648,2.648,0,0,1-.155-.487,2.7,2.7,0,0,1,.127-1.55,5.274,5.274,0,0,1,.389-2.844,5,5,0,0,1,2.305-2.375,4.818,4.818,0,0,1,.781-3.3,4.59,4.59,0,0,1,3.527-1.791A5.04,5.04,0,0,1,89.4,53.669a4.654,4.654,0,0,1,.974-.1,6.126,6.126,0,0,1,3.544,1.275,6.127,6.127,0,0,1,3.545-1.275,4.654,4.654,0,0,1,.974.1,5.041,5.041,0,0,1,2.682,1.612,4.572,4.572,0,0,1,3.531,1.8,4.815,4.815,0,0,1,.78,3.3,5,5,0,0,1,2.306,2.375,5.662,5.662,0,0,1,.139,4A5.675,5.675,0,0,1,107.6,71.374Z",
    transform: "translate(-77.18 -50.77)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_107369",
    "data-name": "Group 107369",
    transform: "translate(3.748 4.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162096",
    "data-name": "Path 162096",
    d: "M97.688,61.041a4.45,4.45,0,0,0-3.624-1.1,3.811,3.811,0,0,0-2.273,1.618A3.577,3.577,0,0,0,88.7,62.8a4.113,4.113,0,0,0-.344,3.334,3.724,3.724,0,0,0-2.811,4.594,1.281,1.281,0,0,0,.062,1.585,4.215,4.215,0,0,0,.224,3.275,3.959,3.959,0,0,0,2.118,1.7,1.285,1.285,0,0,0,.226.381,3.683,3.683,0,0,0,.6,3.148,3.766,3.766,0,0,0,2.8,1.119A2.541,2.541,0,0,0,93.458,84.1l.048.008a6.734,6.734,0,0,0,.682.036c2.97,0,3.619-2.16,3.625-2.183l.013-20.811ZM95.643,77.3a1.3,1.3,0,0,0,.238-.5l1.237.06V76.15l-1.28-.062a1.3,1.3,0,0,0-.565-.695l.246-2.192,1.6,1.51v5.612Zm-5.261-.94a1.3,1.3,0,0,0-.37-.53l.827-1.4,2.582,1.549a1.194,1.194,0,0,0-.06.165ZM93.909,70.7a1.292,1.292,0,0,0,.163-.676l3.044-.4v4.1Zm.248-5.007a1.291,1.291,0,0,0,.174-.039l2.459,3.3-2.941.386a1.306,1.306,0,0,0-.211-.237Zm2.959,3.838-.023-.173.023.03Zm-2.182-4.257a1.278,1.278,0,0,0,.249-1.331l1.933-1.805V68.2Zm-1.514.316c.011.005.02.012.031.017l-.484,3.176a1.249,1.249,0,0,0-.892.186l-1.13-1.067ZM91.6,69.5a1.292,1.292,0,0,0-.136.552l-3.674.8,2.635-2.462Zm-3.7,2.054,3.746-.816a1.3,1.3,0,0,0,.322.364L90.59,73.452l-2.728-1.636A1.271,1.271,0,0,0,87.9,71.557Zm4.737-.186a1.194,1.194,0,0,0,.768-.162l1.462,1.381-.293,2.619a1.345,1.345,0,0,0-.244.027,1.307,1.307,0,0,0-.449.192L91.2,73.817Zm1.572-10.735a3.526,3.526,0,0,1,2.7.727l-2.154,2.013a1.277,1.277,0,0,0-1.347-.144l-.992-1.33A3.079,3.079,0,0,1,94.213,60.636Zm-4.937,2.572a2.915,2.915,0,0,1,2.532-.935L92.871,63.7a1.3,1.3,0,0,0,.006,1.432l-2.448,2.286-1.323-1.25A3.671,3.671,0,0,1,89.276,63.207ZM86.4,68.519a3.479,3.479,0,0,1,2.306-1.752l1.2,1.137L87.28,70.36a1.3,1.3,0,0,0-.949-.162,1.281,1.281,0,0,0-.146.047A3.174,3.174,0,0,1,86.4,68.519Zm.045,6.709a3.412,3.412,0,0,1-.214-2.507,1.269,1.269,0,0,0,1.267-.3l2.732,1.639-.866,1.469A1.288,1.288,0,0,0,87.9,76.5,3.12,3.12,0,0,1,86.444,75.229Zm2.867,5.118a2.837,2.837,0,0,1-.485-2.269,1.294,1.294,0,0,0,1.62-1.007l2.907-.215a1.292,1.292,0,0,0,.419.654L91.7,81.219A3.175,3.175,0,0,1,89.311,80.347Zm4.3,3.055a1.835,1.835,0,0,1-1.337-1.749L94.422,77.8a1.3,1.3,0,0,0,.461-.012,1.236,1.236,0,0,0,.18-.058l2.024,4.146C96.908,82.289,96.121,83.643,93.607,83.4Z",
    transform: "translate(-85.298 -59.869)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162097",
    "data-name": "Path 162097",
    d: "M126.443,71.639a4.515,4.515,0,0,0,.069-3.408,4.068,4.068,0,0,0-2.6-2.1,4.115,4.115,0,0,0-.344-3.334,3.559,3.559,0,0,0-3.093-1.237,3.814,3.814,0,0,0-2.274-1.618,4.451,4.451,0,0,0-3.624,1.1l-.14.107V81.862l.014.1c.006.023.655,2.183,3.625,2.183a6.724,6.724,0,0,0,.682-.036l.048-.008a2.541,2.541,0,0,0,1.887-2.166,3.767,3.767,0,0,0,2.8-1.119,3.846,3.846,0,0,0,.55-3.436,4.078,4.078,0,0,0,2.395-1.793A4.588,4.588,0,0,0,126.443,71.639Zm-.626,3.59a3.482,3.482,0,0,1-2.157,1.513l-3.289-1.7V72.733a1.111,1.111,0,1,0-.71-.006V75.48l3.641,1.876a3.318,3.318,0,0,1-.351,2.991,1.989,1.989,0,0,1-.168.174L117.591,77.5V75.152a1.109,1.109,0,1,0-.71.084v2.677l5.22,3.031a4.086,4.086,0,0,1-1.715.266l-.4-.039.008.4a1.832,1.832,0,0,1-1.34,1.829,3.462,3.462,0,0,1-3.072-.9l1.6-.951a1.11,1.11,0,1,0-.344-.8,1.134,1.134,0,0,0,.017.169l-1.666.991c-.019-.043-.035-.08-.043-.105V61.5a4.805,4.805,0,0,1,1.736-.842v5.213a1.112,1.112,0,1,0,.71,0V60.586a2.525,2.525,0,0,1,.451.048,3.2,3.2,0,0,1,1.922,1.453l.1.192.218-.007a3.021,3.021,0,0,1,2.7.936,3.634,3.634,0,0,1,.18,2.928l-2.646,1.72V65.91a1.117,1.117,0,1,0-.71.042v2.364l-1.786,1.161a1.112,1.112,0,1,0,.325.785,1.057,1.057,0,0,0-.014-.139l5.183-3.369a3.555,3.555,0,0,1,2.3,1.676l-2.965,2.2v2.374a1.112,1.112,0,1,0,.71,0V70.993l2.494-1.854a4.307,4.307,0,0,1-.315,2.337l-.067.139.056.144A4.018,4.018,0,0,1,125.818,75.229Z",
    transform: "translate(-100.984 -59.869)",
    fill: "url(#linear-gradient-15)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_162149",
    "data-name": "Path 162149",
    d: "M4.234-9.315A2.749,2.749,0,0,1,7.062-6.381,2.749,2.749,0,0,1,4.234-3.448,2.753,2.753,0,0,1,1.388-6.381,2.753,2.753,0,0,1,4.234-9.315Zm0,6.446a3.373,3.373,0,0,0,3.46-3.513,3.387,3.387,0,0,0-3.46-3.531A3.391,3.391,0,0,0,.756-6.381,3.377,3.377,0,0,0,4.234-2.869ZM5.762-7.154A1.125,1.125,0,0,0,4.5-8.3H2.864V-4.52h.755V-6.013h.4L4.989-4.52l.9-.018L4.831-6.048A1.06,1.06,0,0,0,5.762-7.154ZM4.445-7.611c.316,0,.562.141.562.474,0,.351-.246.492-.562.492H3.619v-.966Z",
    transform: "translate(260.883 30.277)",
    fill: "#002535"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbrillLogo);
export default __webpack_public_path__ + "static/media/embrill-logo.4ad5c1e8a5b0c4237d0201b79863c7d0.svg";
export { ForwardRef as ReactComponent };